import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../components/layout';
import Header from '../../components/header';
import Icon from '../../components/icons';
import { MAP_KEY, URLS } from '../../_config';
import { useNavigate, useParams } from 'react-router-dom';
import { useAssetsApi } from '../../store/api/hooks/assetsApiHook';
import toast from 'react-hot-toast';
import { useAppLoader } from '../../_common/pageLoader/appLoaderHook';
import { GoogleMap, InfoWindow, LoadScript, Marker, Polygon, Polyline } from '@react-google-maps/api';
import moment from 'moment';
import Tippy from '@tippyjs/react';
import { useFacilitiesApi } from '../../store/api/hooks/facilitiesApiHook';
const MoveLocationHistoryMapView: React.FC = () => {
    const params: any = useParams();
    const assetsAPI = useAssetsApi();
    const facilityApi: any = useFacilitiesApi();

    const { showLoader, hideLoader } = useAppLoader();
    const lineOptions = {
        strokeColor: '#FF0000',
        strokeOpacity: 0.8,
        strokeWeight: 3,
        fillColor: '#FF0000',
        clickable: false,
        draggable: false,
        editable: false,
        geodesic: true,
    };

    const polygonOptions = {
        fillColor: `#FF000070`,
        fillOpacity: 0.2,
        strokeColor: `#FF1818`,
        strokeWeight: 2,
        clickable: false,
        draggable: false,
        editable: false,
        geodesic: false,
    };

    const [asset, setAsset] = useState<any>(null);
    const [movelog, setMovelog] = useState<any>(null);
    const [pathCoords, setPathCoords] = useState<any>([
        //{ id: 2, lat: 26.9124, lng: 75.7873, name: `Jaipur` }, // Jaipur
        //{ id: 1, lat: 28.6139, lng: 77.2090, name: `Delhi` }, // Delhi        
        //{ id: 3, lat: 25.5941, lng: 85.1376, name: `Patna` }, // Patna
        //{ id: 4, lat: 22.5726, lng: 88.3639, name: `Kolkata` }, // Kolkata
        //{ id: 5, lat: 19.0760, lng: 72.8777, name: `Mumbai` }, // Mumbai
        //{ id: 6, lat: 12.9716, lng: 77.5946, name: `Bangalore` }  // Bangalore
    ]);
    const [activeMarker, setActiveMarker] = useState(null);

    const onLoadMapCallbackHandler = (map: any) => {
        const bounds = new window.google.maps.LatLngBounds();
        pathCoords.forEach((coord: any) => bounds.extend(coord));
        map.fitBounds(bounds);
    };

    const init_page_data = async (AssetID = params.id) => {
        showLoader();
        /* Fetch asset details by AssetID */
        const assetresp:any = await new Promise((resolve, reject) => {
            assetsAPI.getAssetsList({ assetID: AssetID }, async (resp: any) => {
                if (resp && resp.hasOwnProperty(`assetList`) && Array.isArray(resp.assetList)) {
                    resolve(resp.assetList[0]);
                } else {
                    toast.error(`Error while fetching asset details`);
                    reject(null);
                }
            }, (err: any) => {
                toast.error(`Network Error: while fetching asset details`);
                reject(err);
            })
        }).catch((err) => {
            return null;
        });
        if (assetresp) {
            

            /* Get Facility details for lat and lng as API team couldn't perform inner join in db */
            /*
            const facilityresp:any = await new Promise((resolve, reject) => {
                facilityApi.getFacilityList({ FacilityID: assetresp?.facilityID }, (resp: any) => {
                    if (resp && resp.hasOwnProperty(`facilityList`) && (Array.isArray(resp.facilityList) || resp.facilityList == null)) {
                        resolve(Array.isArray(resp.facilityList) &&  resp.facilityList.length > 0? resp.facilityList[0] : null);
                    } else {
                        toast.error(`Error while fetching asset's facility`);
                        reject(null);
                    }
                }, (error: any) => {
                    toast.error(error);
                    reject(error);
                });
            }).catch((err) => {
                return [];
            });
            if (facilityresp) {
                assetresp.lat = facilityresp.latitude || 0;
                assetresp.long = facilityresp.longitude || 0;
            }
            */
            setAsset(assetresp);

            /* Fetch move assets history log */
            let logresp:any = await new Promise((resolve, reject) => {
                assetsAPI.GetAssetMovementLogList({ AssetID: AssetID, ProcessName: 'MoveAsset' }, (resp: any) => {
                    if (resp && resp.hasOwnProperty(`assetMovementHistoryList`) && (Array.isArray(resp.assetMovementHistoryList) || resp.assetMovementHistoryList == null)) {
                        resolve(resp.assetMovementHistoryList || []);
                    } else {
                        toast.error(`Error while fetching asset move history`);
                        reject(null);
                    }
                }, (error: any) => {
                    toast.error(error);
                    reject(error);
                });
            }).catch((err) => {
                return [];
            });
            var assetmovementlogrespx = []; 
            if (logresp) {                               
                if (logresp.length > 0) {
                    assetmovementlogrespx = logresp.map((log: any, index: number) => {
                        var genlog:any = {};
                        genlog[`id`] = `log-${index}-${log.assetID}-${log.fromFacilityID}-${log.fromSubFacilityID || `0`}-${log.toFacilityID}-${log.toSubFacilityID || `0`}-${Math.random().toString().split(`.`)[1]}`; // Assigning a unique ID for each log entry                        
                        genlog[`toFacilityName`] = log.toFacilityName || `--`;
                        if (!log.fromSubFacilityID) log.toSubFacilityName = ``;
                        genlog[`toSubFacilityName`] = log.toSubFacilityName || `--`;
                        genlog[`toLat`] = log.toLat || 0;
                        genlog[`toLong`] = log.toLong || 0;
                        genlog[`movementByName`] = log.movementByName;
                        genlog[`bind_movementDateTime`] = log.movementDateTime? moment.utc(log.movementDateTime).local().format(`MM/DD/YY hh:mmA`): `--`;
                        return genlog;
                    });
                }                                                
            }
            /*
            assetmovementlogrespx.unshift({
                id: `log-${999}-${assetresp.assetID}-${assetresp.facilityID}-${assetresp.subFacilityID}-${assetresp.facilityID}-${assetresp.subFacilityID}-${Math.random().toString().split(`.`)[1]}`, // Assigning a unique ID for each log entry
                toFacilityName: assetresp.facilityName || `--`,
                toSubFacilityName: assetresp.subFacilityName || `--`,
                toLat: assetresp.lat || 0,
                toLong: assetresp.long || 0,
                movementByName: assetresp.addedByName,
                bind_movementDateTime: `--`,
            });
            */

            const coordsset = assetmovementlogrespx.map((log: any) => {
                return {
                    id: log.id,
                    lat: +log.toLat,
                    lng: +log.toLong,
                    name: `${log.toFacilityName} ${log.toSubFacilityName ? ` / ${log.toSubFacilityName}` : ``}`
                };
            });
            console.log("assetmovementlogresp", assetmovementlogrespx);                
            console.log("coordsset", coordsset);
            setPathCoords(coordsset);
            setMovelog(assetmovementlogrespx);
        }
        hideLoader();
    };

    useEffect(() => {
        if (params.id) {
            init_page_data(params.id);
        }
    }, [])


    return (
        <Layout>
            <Header title={`Asset Move History - ` + asset?.name} back={URLS.ASSETS_DETAILS(asset?.assetID)}>
                <Header.Right>
                </Header.Right>
            </Header>

            <div className={`mt-3 px-5 flex gap-2`}>
                <div className={`w-1/4 h-[calc(100vh-96px)] overflow-y-auto min-w-[400px]` }>
                    <div className={ `sticky top-0 bg-white z-10` }>
                        <h2 className={`relative after:content-[''] after:absolute after:bottom-0 after:left-3 after:h-[1px] after:w-16 after:bg-black px-3 pt-2 pb-3 font-semibold text-xl`}>Movement Log</h2>
                    </div>
                    {movelog && movelog.length < 1 && (
                        <div className={` text-gray-600 flex flex-col items-center gap-2 mt-12 px-3 pt-6 pb-8 border border-gray-300 rounded-md`}>
                            <Icon name={`info`} size={1.5} /> No movement history found for this asset.
                        </div>
                    )}
                    <div className={ `mt-12 px-5 py-0` }>
                        <ol className={`relative border-s-4 border-black`}>
                            { movelog && movelog.length > 0 && movelog.map((log: any, index: number) => (
                                <li key={ log.id} className={`mb-10 ms-3`}>
                                    <span className={`absolute flex items-center justify-center w-6 h-6 bg-[#8D6E63] rounded-full -start-3.5 ring-0 ring-white`}></span>
                                    <div className={`bg-white rounded-lg shadow-xs px-4 pt-0 pb-2 -mt-3 ${movelog.length > 1 && index === (movelog.length - 1) ? 'relative' : ''}`}>
                                        {(movelog.length > 1 && index === (movelog.length - 1)) && (
                                            <span className={`absolute -left-4 bg-white bottom-0 top-6 w-1`}></span>
                                        )}
                                        <Tippy className={`!bg-grey-300`} animation={`scale`} allowHTML={true} theme={`material`} content={
                                            <div className={`p-2 rounded-md shadow text-[13px]`}>
                                                <div className={`mb-1 font-normal`}><strong>Facility:</strong> {log.toFacilityName || `--` }</div>
                                                <div className={`mb-0 font-normal`}><strong>Sub-Facility:</strong> {log.toSubFacilityName || `--` }</div>
                                            </div>
                                        }>
                                            <h5 className={`text-black font-bold text-sm`}>{log.toFacilityName || `--`} <span className={ `text-gray-400 px-1` }>/</span> {log.toSubFacilityName || `--`} </h5>
                                        </Tippy>                                        
                                        {!(+log.toLong && +log.toLat) && <p className={ `text-red-600 text-xs` }>Invalid location coords</p>}
                                        <p className={`text-xs text-[#767676]  mt-1.5 mb-1.5`}>{log.movementByName}</p>
                                        <p className={`text-xs text-[#999999]`}>{log.bind_movementDateTime}</p>                                        
                                    </div>
                                </li>
                            ))}                            
                        </ol>                        
                    </div>
                </div>
                <div className={ `w-3/4 border h-[calc(100vh-105px)] my-3 rounded-md overflow-hidden` }>
                    <LoadScript googleMapsApiKey={MAP_KEY}> {/* Replace with your API key */}
                        <GoogleMap
                            mapContainerStyle={{
                                width: '100%',
                                height: '100%',
                            }}
                            onLoad={onLoadMapCallbackHandler}
                            center={pathCoords.length > 0? pathCoords[0]: {lat: 38.8938592, lng: -77.0969764}} // Default center if no coords
                            zoom={16}                            
                            mapTypeId={ `hybrid` }
                        >

                            {/* Markers */}
                            {pathCoords.map((coord: any, index: any) => (
                                <Marker key={index} position={coord} onClick={() => setActiveMarker(coord.id)}>
                                    {activeMarker === coord.id && (
                                        <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                                            <div className={ `pl-6 pr-7 pb-6` }>
                                                <h3 className="text-md font-bold">{coord.name}</h3>                                                
                                            </div>
                                        </InfoWindow>
                                    )}
                                </Marker>
                            ))}

                            {/* Overlay polygon */}
                            <Polygon path={pathCoords} options={polygonOptions} />
                        </GoogleMap>
                    </LoadScript>
                </div>
            </div>

        </Layout>
    );
};

export default MoveLocationHistoryMapView;